<template>
  <header class="bg-(--brand-taupe) text-white">
    <div
      class="flex page-container items-center justify-between"
      :class="size === 'lg' ? 'py-6 min-[1080px]:py-10' : 'py-5'"
    >
      <!-- The logo image carries a bar above the „MD CLUB" wordmark, so its box centre sits
           ~8px above the text's. On mobile the link drops by that much to line up with it. -->
      <NuxtLinkLocale
        :to="to"
        class="flex items-center gap-2 tracking-[0.08em] max-md:translate-y-2 whitespace-nowrap uppercase text-white transition hover:text-white min-[1080px]:tracking-[0.18em]"
        :class="size === 'lg' ? 'text-sm font-normal min-[1080px]:text-base' : 'text-sm'"
      >
        <span aria-hidden>←</span> {{ label ?? t('Zpět na mdclub.cz') }}
      </NuxtLinkLocale>
      <SiteLogo />
    </div>
  </header>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

withDefaults(
  defineProps<{
    /** Link target. */
    to?: RouteLocationRaw
    /** Override the back-link label (defaults to "Zpět na mdclub.cz"). */
    label?: string
    /** lg = tall checkout header (order), sm = compact (login). */
    size?: 'sm' | 'lg'
  }>(),
  { to: () => ({ name: 'index' }), size: 'sm' }
)

const {
  $i18n: { t },
} = useNuxtApp()
</script>
